import { MdCheck } from "react-icons/md";
import Modal from "../Modal/Modal";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import { ICON_SIZES } from "src/constants/icons";
import { EButtonKind } from "../Button/Button.types";

interface IAlertDialog {
  title: string;
  onClose: () => void;
  description: string;
  isLoading?: boolean;
  note?: string;
}

const AlertDialog: React.FC<IAlertDialog> = ({
  title,
  onClose,
  description,
  isLoading = false,
  note = "",
}) => {
  const { t } = useTranslation(["common", "misc"]);

  return (
    <Modal
      width="md:!max-w-[520px] md:!min-w-[400px]"
      onEscape={() => {
        if (!isLoading) {
          onClose();
        }
      }}
      className="!shadow"
      closeOnOverlayClick={!isLoading}
    >
      <Modal.Header
        onClose={() => {
          if (!isLoading) {
            onClose();
          }
        }}
        title={title}
      />
      <Modal.Body>
        <div className={clsx(["flex", "flex-col", "w-full", "gap-4"])}>
          <div className={clsx(["flex", "w-full", "flex-col", "gap-2"])}>
            <p className={clsx(["text-xs", "md:text-sm"])}>{description}</p>
            {note && <p className={clsx(["warning-text"])}>{note}</p>}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer
        actions={[
          {
            kind: EButtonKind.NORMAL,
            onClick: onClose,
            text: t("common:buttons.accept"),
            icon: <MdCheck size={ICON_SIZES.SM} />,
            isLoading,
            autoFocus: true,
          },
        ]}
      />
    </Modal>
  );
};

export default memo(AlertDialog);
